import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { vendorReportConfig } from '@webapp/modules/reports/config/reportConfigs'

const ReportAggregateViewChunk = lazy(() =>
  import('@webapp/modules/reports/feature-sets/ReportAggregateView').then(
    ({ ReportAggregateView }) => ({
      default: ReportAggregateView,
    })
  )
)

export const OrdersByVendorReportPage = () => {
  const intl = useProcurifyIntl()
  const pageTitle = intl.formatMessage(vendorReportConfig.titleKey)

  return (
    <Page pageTitle={pageTitle} breadcrumbs={[{ name: pageTitle }]}>
      <ReportAggregateViewChunk reportConfig={vendorReportConfig} />
    </Page>
  )
}
